import axios from "axios";

// Update consumer warranty details
// params: { id: string, body: object }
const put = ({ id, body }) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/serialnumber/api/v1/consumer-warranty/${id}`, body)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data ?? error));
  });
};

const updateConsumerWarranty = {
  put,
};

export default updateConsumerWarranty; 